import { render, staticRenderFns } from "./AppBarNotificationComponent.vue?vue&type=template&id=3a50b86e&scoped=true&"
import script from "./AppBarNotificationComponent.vue?vue&type=script&lang=js&"
export * from "./AppBarNotificationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a50b86e",
  null
  
)

export default component.exports